module.exports = __webpack_public_path__ + "img/service2.5e97cb38.svg";